import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"

import {Page} from "@indebted/components/Page"
import {TextToHTML} from "@indebted/components/TextToHTML"
import {Prop, PropLabel, Props, PropValue} from "@indebted/components/Props"

function PaymentPlanCancelledByCustomer({
	PaymentPlanInstalmentAmount,
	PaymentPlanFrequency,
	PaymentPlanStartDate,
	PaymentPlanEndDate,
	ClientName,
	I18n,
}) {
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{I18n.CancelledByCustomer.Title}
				</Typography>
			</Grid>

			<Grid>
				<TextToHTML align="left" text={I18n.CancelledByCustomer.Message} className="amp-mask" />
			</Grid>

			<Grid>
				<Typography>{I18n.CancelledByCustomer.DetailsTitle}</Typography>
			</Grid>
			<Props>
				<Prop>
					<PropLabel align="right">{I18n.CancelledByCustomer.PlanLabel}</PropLabel>
					<PropValue align="left">
						{PaymentPlanInstalmentAmount} {PaymentPlanFrequency}
					</PropValue>
				</Prop>
				<Prop>
					<PropLabel align="right">{I18n.CancelledByCustomer.PaidToLabel}</PropLabel>
					<PropValue align="left" className="amp-mask">
						{ClientName}
					</PropValue>
				</Prop>
				<Prop>
					<PropLabel align="right">{I18n.CancelledByCustomer.StartDateLabel}</PropLabel>
					<PropValue align="left">{PaymentPlanStartDate}</PropValue>
				</Prop>
				<Prop>
					<PropLabel align="right">{I18n.CancelledByCustomer.EndDateLabel}</PropLabel>
					<PropValue align="left">{PaymentPlanEndDate}</PropValue>
				</Prop>
			</Props>
		</Page>
	)
}
export {PaymentPlanCancelledByCustomer}
